import * as React from 'react';
import { GtmEventsBase } from '../GoogleTagManager/GtmEventsBase';
import type { GtmPageStatsViewModel } from './GtmPageStatsViewModel.csharp';

export const GtmPageStats: React.FC<React.PropsWithChildren<GtmPageStatsViewModel>> = props => {
    React.useEffect(() => {
        GtmEventsBase.pushGtmPageStats(props);
    }, []);

    return null;
};
